const WhiteButton = (props) => {
    const { children, ...otherProps } = props;
  
    let className = "relative whitespace-nowrap hover:cursor-pointer inline-block px-4 md:px-6 h-12 outline-none text-base rounded-3xl md:rounded-2xl transition duration-200 bg-white hover:bg-gray-100 text-gray-800";
  
    return (
      <button {...otherProps} className={className}>
        {children}
      </button>
    );
};

export default WhiteButton;
  
  